// extracted by css-extract-rspack-plugin
export default {"cls1":"FocusedNavView-cls1_oEU","cls2":"FocusedNavView-cls2_HjU FocusedNavView-cls1_oEU","useGrid":"FocusedNavView-useGrid_-R9"};